<template>
  <modal ref='modal' class="recommend">
    <template #header>
      <h5 class="modal-title mt-0">
        <img src="../assets/recommend-icon.svg" />
        {{ $t('recommend_relatico.title')}}
      </h5>
    </template>

    <template #body>
      <div v-show='recommendationSent' class="thankyou">
        <img src="../assets/thankyou.svg" />
        <p>{{$t('recommend_relatico.thankyou')}}</p>
      </div>

      <div v-show='!recommendationSent'>
        <ul>
          <li>
            <img src="../assets/recommend1.svg" />
            <p>{{$t('recommend_relatico.benefit1')}}</p>
          </li>
          <li>
            <img src="../assets/recommend2.svg" />
            <p>{{$t('recommend_relatico.benefit2')}}</p>
          </li>
          <li>
            <img src="../assets/recommend3.svg" />
            <p>{{$t('recommend_relatico.benefit3')}}</p>
          </li>
        </ul>

        <form @submit.prevent='recommend'>
          <fieldset>
            <div class="form-group">
              <label>{{$t('recommend_relatico.label')}}</label>
              <multi-select class='form-control' :template='contactTemplate' :getter='getContacts' v-model='selectedContacts' name='contact_ids[]' />
            </div>
            <div class="form-group float-right">
              <a @click.prevent='close()' class="btn btn-neutral m-r-10">{{ $t('recommend_relatico.cancel') }}</a>
              <button type="submit" class="btn btn-primary">
                <i class="far fa-envelope"></i>
                {{ $t('recommend_relatico.send') }}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </template>
  </modal>
</template>

<script>
  import _modal from './_modal'
  import _multi_select from './shared/_infinite_multi_select'

  export default {
    components: {
      modal: _modal,
      'multi-select': _multi_select,
    },
    data() {
      return {
        recommendationSent: false,
        selectedContacts: [],
      }
    },
    methods: {
      open() {
        this.recommendationSent = false
        this.selectedContacts = []
        this.$refs.modal.open()
      },
      close() {
        this.$refs.modal.close()
      },
      recommend(e) {
        this.recommendationSent = true
        this.store.recommendContact(new FormData(e.target))
        this.store.sendMetrics({name: 'recommend_contact', params: this.$route.params, path: this.$route.fullPath})
      },
      getContacts(params) {
        return this.listStore.getContacts(params)
      }
    }
  }
</script>

<style lang='sass' scoped>
  h5
    img
      width: 26px
      margin: 0 5px 3px 0
  ul
    list-style: none
    margin: 25px 0
    padding: 0
    display: flex
    li
      text-align: center
      p
        width: 90%
        margin: 10px auto 0
        font-size: 16px
  form
    padding: 0 20px
  .thankyou
    text-align: center
    padding: 20px 0
    p
      font-size: 16px
      padding: 15px 0
      font-weight: 500
      width: 60%
      margin: 0 auto
</style>
